/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorHikingTripTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorHikingTrip,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Go Hiking Together!",
    "Outdoor Hiking Trip Awaits!",
    "Adventure in Nature for Everyone!",
  ],
  title: "Outdoor Hiking Trip",
  description: "Organize a fun outdoor hiking trip.",
  longDescription:
    "Gather your friends for an exciting hiking trip! Choose a date, decide on trails to explore, and plan snacks!",
  emoji: "🥾",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Hiking Trip",
          emoji: "🥾",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we go for the hiking trip?",
          emoji: "📅",
          completeAction: {
            question: "Decide on trails to explore?",
            description: "What trails should we focus on for our hiking trip?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What trails should we consider?",
                emoji: "⛰",
                completeAction: {
                  question: "Decide on snacks to bring?",
                  description: "What snacks should we prepare for the hike?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What snacks should we bring?",
                      emoji: "🍎",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Hike Together!",
    outroDescription:
      "Your outdoor hiking trip plans are set! Enjoy the adventure!",
  },
};
